import { createSlice } from "@reduxjs/toolkit";

const slotSlice = createSlice({
    name: 'slot',
    initialState: {
        isLoading: false,
        message: null,
        successStatus: null,
        slot: null,
        timeZone: null
    },
    reducers: {
        getSlotStart: (state) => {
            state.message = null;
            state.successStatus = null;
            state.isLoading = true;
        },
        getSlotSuccess: (state, action) => {
            state.slot = action?.payload?.slots;
            state.message = action?.payload?.message;
            state.isLoading = false;
            state.successStatus = action?.payload?.success;
            state.timeZone = action?.payload?.timeZone;
            state.shiftDays = action?.payload?.shiftDays
        },
        getSlotFailure: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message
            state.successStatus = action?.payload?.success;
        },
        selectDateTimeStart: (state) => {
            state.message = null;
            state.successStatus = null;
            state.isLoading = true; 
        },
        selectDateTimeSuccess: (state, action) => {
            state.slot = action?.payload?.slots;
            state.message = action?.payload?.message;
            state.isLoading = false;
            state.successStatus = action?.payload?.success;
        },
        selectDateTimeFailure: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message
            state.successStatus = action?.payload?.success;
        },
        
    }
});

export const {
    getSlotStart,
    getSlotSuccess,
    getSlotFailure,
    selectDateTimeStart,
    selectDateTimeSuccess,
    selectDateTimeFailure
} = slotSlice.actions

export default slotSlice?.reducer;